import React from 'react';
import { useI18n } from '@/i18n/I18nProvider';

interface DocumentUpdateAppStatusProps {
  statusId: number;
}

export function DocumentUpdateAppStatus({ statusId }: DocumentUpdateAppStatusProps) {
  const { t } = useI18n();

  const getStatusDetails = (id: number) => {
    switch (id) {
      case 1:
        return {
          text: t.inProgress,
          badgeClass:
            'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-800',
        };
      case 2:
        return {
          text: t.returned,
          badgeClass:
            'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800',
        };
      case 3:
        return {
          text: t.approved,
          badgeClass:
            'badge-success bg-green-100 text-green-800 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-800',
        };
      default:
        return {
          text: t.unknown,
          badgeClass:
            'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700',
        };
    }
  };

  const { text, badgeClass } = getStatusDetails(statusId);

  return <div className={`aegov-badge font-medium text-xs border ${badgeClass}`}>{text}</div>;
}
